import { HStack } from "@repo/components/src/ui/hstack";
import { Icon } from "@repo/components/src/ui/icon";
import { Text } from "@repo/components/src/ui/text";
import type { LucideIcon } from "lucide-react-native";
import React from "react";

type Props = {
  icon: LucideIcon;
  label: string;
  value: string;
};

/** Ported from `apps/mobil/.../deliverables/DateChip.tsx`. */
const DateChip = React.memo(({ icon, label, value }: Props) => (
  <HStack
    space="xs"
    className="items-center rounded-full px-3 py-1 bg-brand-50"
  >
    <Icon as={icon} size="2xs" className="text-brand-400" />
    <Text size="2xs" className="text-typography-700">
      {label}
    </Text>
    <Text bold size="2xs" className="text-brand-400">
      {value}
    </Text>
  </HStack>
));

DateChip.displayName = "DateChip";

export default DateChip;
